import qs from 'qs';

import { axiosPrivate } from 'app/utils';
import helpers from './helpers';

export default {
  async getPacks() {
    const response = await axiosPrivate.get('/marketing/packs');

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async requestPack(params) {
    const response = await axiosPrivate.post('/marketing/packs/request', params);

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async getResources({ group, entityType }) {
    const query = qs.stringify({ group, entity_type: entityType });
    const response = await axiosPrivate.get(`/marketing/resources${query ? `?${query}` : ''}`);
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async getResource(pharmacyId, resourceId, download) {
    const response = await axiosPrivate.get(
      `/marketing/pharmacies/${pharmacyId}/resources/${resourceId}/download?download=${download}`
    );
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async sendMarketingEvent(pharmacyId, screen, action, name) {
    const response = await axiosPrivate.post(
      `/marketing/pharmacies/${pharmacyId}/resources/events`,
      { screen, action, name }
    );

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },
};
